<template>
	<main class="home-page">
		<div class="home-page__inner _cnt-home">
			<HomeAside
				class="home-page__aside"
				:isAuth="isAuth"
				@openProductModal="$emit('openProductModal', $event)"
			/>
			<div class="home-page__content">
				<div class="home-page__content-bg _ibg">
					<img src="@/assets/images/bg/home/home-bg.png" />
				</div>

				<HeroSection />

				<BestSalesSection
					:is-auth="isAuth"
					:chosen-item="chosenItem"
					:currency-code="currencyCode"
					:currency-symbol="currencySymbol"
					@addToCart="addToCart"
					@openProductModal="$emit('openProductModal', $event)"
					@openLoginModal="$emit('openLoginModal')"
				/>

				<QuestionsSection :questions="faq"/>

				<BrowseSection
					:is-auth="isAuth"
					:chosen-item="chosenItem"
					:currency-code="currencyCode"
					:currency-symbol="currencySymbol"
					@addToCart="addToCart"
					@openProductModal="$emit('openProductModal', $event)"
					@openCartModal="$emit('openCartModal')"
					@openLoginModal="$emit('openLoginModal')"
				/>

				<ShowSection
					is-auth="isAuth"
					:chosen-item="chosenItem"
					:currency-code="currencyCode"
					:currency-symbol="currencySymbol"
					@addToCart="addToCart"
					@openProductModal="$emit('openProductModal', $event)"
				/>
			</div>
		</div>
	</main>
</template>

<script>
import BestSalesSection from '@/components/Home/BestSalesSection/BestSalesSection.vue';
import BrowseSection from '@/components/Home/BrowseSection.vue';
import HeroSection from '@/components/Home/HeroSection.vue';
import QuestionsSection from '@/components/Home/QuestionsSection.vue';
import ShowSection from '@/components/Home/ShowSection.vue';
import { mapGetters } from 'vuex';
import HomeAside from './HomeAside.vue';

export default {
	name: 'HomePage',
	components: {
		HeroSection,
		BestSalesSection,
		HomeAside,
		QuestionsSection,
		BrowseSection,
		ShowSection,
	},
	props: {
		chosenItem: {
			type: String,
		},
		currencySymbol: {
			type: String,
			required: true,
		},
		isAuth: {
			type: Boolean,
			required: true,
		},
		currencyCode: {
			type: String,
			required: true,
		},
		lang: {
			type: String,
			required: true,
		},
	},
	data: function () {
		return {
			saleProducts: [],
			newArrivals: [],
			activePanels: [],
			faq: [],
		};
	},
	computed: {
		...mapGetters('app', ['currentLanguage']),
	},
	watch: {
		currencyCode() {
			this.getNewArrivals();
			this.getSale();
		},
		lang() {
			this.getFaq();
		},
	},
	async mounted() {
		this.getSale();
		this.getNewArrivals();
		this.getFaq();
	},
	methods: {
		addToCart(item) {
			this.$emit('addToCart', item);
		},
		openSellSkinModal() {
			this.$emit('openSellSkinModal');
		},
		openSignIn() {
			this.$emit('openSignIn');
		},
		openSignUp() {
			this.$emit('openSignUp');
		},
		getFaq() {
			this.$http
				.get(process.env.VUE_APP_API + 'faq')
				.then((res) => {
					this.faq = res.data.payload;
				})
				.catch(() => {});
		},
		getNewArrivals() {
			this.$http
				.get(process.env.VUE_APP_API + 'items/list?new=true')
				.then((res) => {
					this.newArrivals = res.data.payload;
				})
				.catch(() => {});
		},
		getSale() {
			this.$http
				.get(process.env.VUE_APP_API + 'items/list?sale=true')
				.then((res) => {
					this.saleProducts = res.data.payload;
				})
				.catch(() => {});
		},
		goToProduct(item) {
			this.$emit('goToProduct', item);
		},
		togglePanel(index) {
			if (this.isActivePanel(index)) {
				this.activePanels.splice(this.activePanels.indexOf(index), 1);
			} else {
				this.activePanels.push(index);
			}
		},
		isActivePanel(index) {
			return this.activePanels.includes(index);
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.home-page {
	min-height: 100vh;
	&__inner {
		@media (min-width: $md2) {
			display: flex;
			align-items: stretch;
			min-height: 100vh;
			padding-left: 0;
		}
		display: flex;
		align-items: stretch;
		min-height: 100vh;
		padding-left: 0;
	}
	&__aside {
	}
	&__content {
		@media (min-width: $md2) {
			@include adaptiveValue('margin-left', 280, 140, 1920, 992, 1);
			@include adaptiveValue('padding-left', 95, 0, 1920, 992, 1);
		}
		@media (max-width: $md2) {
			padding-left: 10px;
		}
		flex: 1 1 auto;
		position: relative;
		&-bg {
			z-index: -1;
			position: absolute;
			width: calc(100% + 20px);
			height: 100%;
			top: 0;
			left: -10px;
		}
	}
}
</style>
